import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

const MainContainer = styled.div`
    margin-bottom: 0.5em;
`;

const Label = styled.label.attrs(
    (props) =>
        props.width && {
            style: { width: props.width, display: 'inline-block' },
        }
)``;

const Select = styled(ReactSelect).attrs(
    (props) =>
        props.width && {
            style: { width: props.width, display: 'inline-block' },
        }
)``;

const SelectList = ({
    label,
    labelWidth,
    inputWidth,
    options = [],
    value,
    onChange,
    id,
    disabled,
    placeholder = ' -- select an option -- ',
    className,
    ...props
}) => {
    const handleChange = (option) => {
        onChange?.(option?.value);
    };

    return (
        <MainContainer className={className}>
            {label && (
                <Label width={labelWidth} htmlFor={id}>
                    {label}
                </Label>
            )}

            <Select
                value={options.find((o) => o.value === value) || ''}
                onChange={handleChange}
                width={inputWidth}
                id={id}
                isDisabled={disabled}
                options={options}
                placeholder={placeholder}
                {...props}
                // getOptionValue={(opt) => opt.value}
                // getOptionLabel={(opt) => opt.label}
            >
                {/* <option hidden disabled value="" key="">
                    {noValueLabel}
                </option>
                {options.map((option) => {
                    return (
                        <Option value={option.value} key={option.value}>
                            {option.label}
                        </Option>
                    );
                })} */}
            </Select>
        </MainContainer>
    );
};

SelectList.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.node,
        })
    ),
    label: PropTypes.node,
    value: PropTypes.any,
    onChange: PropTypes.func, // function(value){}
    labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inputWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SelectList;
